export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/socks.50051ef.svg";